module.exports = __webpack_public_path__ + "static/img/1_3_1.72b6f447.jpg";